__webpack_require__.p = "/projects/MNISTneuralnet/build/";